import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import SmartFaqComponents from './smart-faq.components';
import useReasons from '../../hooks/use-reasons.hook';
import useSmartFaq from '../../hooks/use-smart-faq.hook';
import { PORTAL_TYPE } from '../../types/app.types';
import { useParamsContext } from '../../params/params-context';

const additionalLink: { [key in PORTAL_TYPE]: string } = {
  [PORTAL_TYPE.ERDE]: 'https://www.edenred.de/akzeptanzpartner/faq/',
  [PORTAL_TYPE.ER1]: 'https://www.edenred-one.de/haeufige-fragen/',
  [PORTAL_TYPE.EBUSER]: 'https://www.mein-edenred.de/hilfe-kontakt-public',
  [PORTAL_TYPE.EBCLIENT]: 'https://www.edenred-one.de/haeufige-fragen/',
  [PORTAL_TYPE.UMER]: 'https://www.mein-edenred.de/hilfe-kontakt-public',
  [PORTAL_TYPE.FMER]:
    'https://firmenkunden.mein-edenred.de/Fragen_und_Antworten.htm'
};

const {
  FaqContainer,
  SmartFaqArea,
  AdditionalLink,
  StyledLinkText,
  LinkContainer
} = SmartFaqComponents;

const SmartFaq: React.FunctionComponent = () => {
  const { mainReasonValue } = useReasons();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const { initFAQ, event, sourceConfig } = useSmartFaq();
  const { portalType } = useParamsContext();

  const checkIfEmpty = useCallback((): void => {
    const questionList = document.getElementsByClassName('question-list');
    if (questionList.length) {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('STFAQContextLoaded', initFAQ as EventListener);
    if (event) {
      setIsLoaded(false);
      dispatchEvent(event);
    }
    return (): void => {
      window.removeEventListener(
        'STFAQContextLoaded',
        initFAQ as EventListener
      );
    };
  }, [event, initFAQ]);

  useEffect(() => {
    if (isLoaded) {
      return (): void => {
        clearInterval(id);
      };
    }
    const id = setInterval(checkIfEmpty, 500);

    return (): void => {
      clearInterval(id);
    };
  }, [checkIfEmpty, isLoaded, sourceConfig]);

  if (!mainReasonValue) {
    return null;
  }

  return (
    <SmartFaqArea>
      <FaqContainer id="st-faq-context" isHidden={!isLoaded} />
      {isLoaded && (
        <LinkContainer>
          <AdditionalLink
            target="_blank"
            href={portalType ? additionalLink[portalType] : additionalLink.ERDE}
            rel="smart-faq">
            <StyledLinkText tParams="app.smartFaqLink" />
          </AdditionalLink>
        </LinkContainer>
      )}
      <Helmet>
        <script
          type="text/javascript"
          async
          src="https://assets.app.smart-tribune.com/smart-tribune/FAQContext/faqcontext.main.js"
        />
      </Helmet>
    </SmartFaqArea>
  );
};

export default SmartFaq;
